
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/[slug]",
      function () {
        return require("private-next-pages/sa/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/[slug]"])
      });
    }
  